import styled from 'styled-components'
import { IconComponent, themeColor } from 'LibNeo'

export const LoaderIcon = styled(IconComponent)`
	width: 120px;
	height: 120px;
	svg {
		width: 120px;
		height: 120px;
	}
`
export const LoaderWrapper = styled.div<{ isVisible: boolean }>`
	position: fixed;
	left: 0;
	top: 0;
	z-index: 2147483647;
	visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
	background-color: rgba(29, 44, 61, 0.6);
	transition: visibility 0s linear;
	display: flex;
	width: ${({ isVisible }) => (isVisible ? 'auto' : '0')};
	height: ${({ isVisible }) => (isVisible ? 'auto' : '0')};
    color: ${themeColor('emerald', 6)};
	font-size: 90px;
	align-items: ${({ isVisible }) => (isVisible ? 'center' : 'unset')};
	justify-content: ${({ isVisible }) => (isVisible ? 'center' : 'unset')};
	bottom: ${({ isVisible }) => (isVisible ? '0' : 'unset')};
	right: ${({ isVisible }) => (isVisible ? '0' : 'unset')};
	transition-delay: ${({ isVisible }) => (isVisible ? '0.3s' : '0s')};
	}
`
